<template>
    <div class="chooseAcc d-flex flex-column flex-lg-row align-items-center justify-content-start justify-content-lg-center position-relative w-100">
        <img class="img-fuid left dotsBg" src="../../../../static/fxView/images/registerflow-new/leftshape.png">
        <img class="img-fuid right dotsBg" src="../../../../static/fxView/images/registerflow-new/rightshape.png">
        <img class="img-fuid logo mx-auto d-block d-lg-none logoImg" src="../../../../static/fxView/images/registerflow-new/logo.svg">
        <div class="innerBox">
            <img class="img-fuid logo mb-4 mx-auto d-none d-lg-block" src="../../../../static/fxView/images/registerflow-new/logo.svg">
            <div class="subtitle text-center pb-1">
                <h3 class="mb-2">Select Trading Account</h3>
                <p class="mb-3 lh-20">Explore risk-free with a Demo Account or dive into the real market with a Live Account.</p>
            </div>
            <div class="accTypes d-flex align-items-center justify-content-center mb-4">
                <div class="accItem" 
                    :class="{ 'selected-account': get_user.demo_live_selection == 0 }" 
                    @dblclick="proceedWithSelection(acc_type)">
                    <input type="radio" name="accType" v-model="acc_type" value="0" @change="onChange($event)">
                    <div class="contentBox">
                        <img class="img-fuid mb-3 black" src="../../../../static/fxView/images/registerflow-new/demoacc.svg">
                        <img class="img-fuid mb-3 theme" src="../../../../static/fxView/images/registerflow-new/demoacc-theme.svg">
                        <h4 class="f-18 medium">Demo Account</h4>
                    </div>
                </div>
                <div class="accItem" 
                    :class="{ 'selected-account': get_user.demo_live_selection == 1 }"
                    @dblclick="proceedWithSelection(acc_type)">
                    <input type="radio" name="accType" v-model="acc_type" value="1" @change="onChange($event)">
                    <div class="contentBox">
                        <img class="img-fuid mb-3 black" src="../../../../static/fxView/images/registerflow-new/liveacc.svg">
                        <img class="img-fuid mb-3 theme" src="../../../../static/fxView/images/registerflow-new/liveacc-theme.svg">
                        <h4 class="f-18 medium">Live Account</h4>
                    </div>
                </div>
            </div>
            <a href="#" class="prism_btn w-100 mb-3" v-on:click.stop.prevent="liveDemoFormFunc(acc_type)">Submit</a>
            <div class="charlgateMsg border-top pt-2 text-center">
                <small>Finvasia Capital (PTY) Ltd company registered in South Africa with Company Number 2018/303451/07. The Registered Office Address is 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.</small>
            </div>
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'chooseAccount',
        mixins: [fxViewMixins],
        data() {
            return {
                acc_type: '',
            }
        },
        methods: {
            onChange(e) {
                this.acc_type = e.target.value;
            },
            proceedWithSelection(accType) {
                this.chooseDemoLive();
                this.liveDemoFormFunc(accType);
            },
            chooseDemoLive(){
				const _that = this
				let input_json={
					'globalParams' :{
                        "account_type": (_that.acc_type == 1 ? 'live' : 'demo'),
                    },
					'localParams' :{
						"parameter" : _that
					}
				}
				_that._runChooseLiveDemo(input_json)
			},
            liveDemoFormFunc(getData) {
                this.chooseDemoLive();
                if(getData == '0') {
                    this.$router.replace('/create_demo_account');
                } else if ( getData == '1') {
                    this.$router.push('/step1');
                } else {
                    this.$router.push('/choose-account');
                }
            },
        },
        created(){
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/choose-account.vue